import { useEffect, useState } from "react";
import { cdName } from "../lib/filename";
import { toast } from "sonner";
import { FileSpreadsheet, ShoppingCart, Paperclip } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { eur, frDate, StatusBadge, Table, Empty } from "./equipment/common";
import { openPdf } from "./equipment/OrderDialogs";

export const PayrollEquipmentOrders = ({ start, end }) => {
  const [d, setD] = useState(null);
  useEffect(() => { if (start && end) http.get("/payroll/equipment-orders", { params: { start, end } }).then((r) => setD(r.data)).catch(() => setD(null)); }, [start, end]);
  const csv = async () => {
    try {
      const r = await http.get("/payroll/equipment-orders.csv", { params: { start, end }, responseType: "blob" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = cdName(r.headers["content-disposition"], "Bons de commande équipements.csv"); a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 10000);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  if (!d) return null;
  return (
    <section className="space-y-3" data-testid="payroll-equipment-orders">
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex-1">
          <h2 className="font-display text-xl font-bold flex items-center gap-2"><ShoppingCart className="h-5 w-5 text-[#C8922E]" />Bons de commande d'équipements</h2>
          <p className="text-xs text-slate-500">Commandes envoyées ou réceptionnées sur la période — relevé pour la comptabilité (aucune retenue sur la paie).</p>
        </div>
        <div className="text-sm text-right" data-testid="payroll-eq-totals">HT <b>{eur(d.total_ht)}</b> · TVA {eur(d.total_vat)} · TTC <b>{eur(d.total_ttc)}</b></div>
        <button onClick={csv} disabled={!d.orders.length} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md border border-slate-300 text-sm font-semibold hover:bg-slate-50 disabled:opacity-50" data-testid="payroll-eq-csv"><FileSpreadsheet className="h-4 w-4" />Export comptable (CSV)</button>
      </div>
      <Table head={["N°", "Date", "Fournisseur", "Détail par agent", "HT", "TTC", "Facture fournisseur", "Statut"]} testid="payroll-eq-table">
        {d.orders.length === 0 && <tr><td colSpan={8}><Empty>Aucun bon de commande sur la période</Empty></td></tr>}
        {d.orders.map((o) => (
          <tr key={o.id} data-testid={`payroll-eq-row-${o.id}`}>
            <td className="px-3 py-2"><button className="font-mono font-semibold text-sky-700 hover:underline" onClick={() => openPdf(`/payroll/equipment-orders/${o.id}/pdf`)}>{o.number}</button></td>
            <td className="px-3 py-2 whitespace-nowrap">{frDate(o.received_at || o.sent_at)}</td>
            <td className="px-3 py-2">{o.supplier.name}<div className="text-[11px] text-slate-500">{o.supplier.siret && `SIRET ${o.supplier.siret}`}</div></td>
            <td className="px-3 py-2 text-xs">{o.lines.filter((l) => !l.removed).map((l) => <div key={l.id}>{l.agent_name} — {l.quantity} × {l.name}{l.size ? ` (${l.size})` : ""} · {eur(l.quantity * l.unit_price_ht)}</div>)}</td>
            <td className="px-3 py-2 whitespace-nowrap">{eur(o.total_ht)}</td>
            <td className="px-3 py-2 whitespace-nowrap font-semibold">{eur(o.total_ttc)}</td>
            <td className="px-3 py-2 text-xs">{o.invoice ? <button className="text-sky-700 font-semibold hover:underline inline-flex items-center gap-1" onClick={() => openPdf(`/payroll/equipment-orders/${o.id}/invoice`)} data-testid={`payroll-eq-invoice-${o.id}`}><Paperclip className="h-3.5 w-3.5" />{o.invoice.number || "Facture"}{o.invoice.amount_ttc != null && ` · ${eur(o.invoice.amount_ttc)}`}</button>
              : <span className="text-amber-700">Non jointe</span>}</td>
            <td className="px-3 py-2"><StatusBadge s={o.status} /></td>
          </tr>
        ))}
      </Table>
    </section>
  );
};
